var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-single"},[[_c('SubHeader'),_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }